import { createTheme } from '@mui/material/styles';

// Omni-Tek Futuristic Metallic Colors
export const OMNITEK_COLORS = {
  // Primary - Metallic Steel
  steel: '#2D3B45', // RGB: 45, 59, 69 (Dark steel gray with blue undertone)

  // Secondary
  darkSteel: '#1A252E', // RGB: 26, 37, 46 (Deep steel)
  cyan: '#00D9FF', // RGB: 0, 217, 255 (Neon cyan accent)
  amber: '#FFB300', // RGB: 255, 179, 0 (Metallic amber/gold)

  // Tertiary
  coral: '#FF5252', // RGB: 255, 82, 82 (Soft coral red)

  // Neutral
  charcoal: '#1E1E1E', // RGB: 30, 30, 30 (Deep charcoal)
  silver: '#E8EAED', // RGB: 232, 234, 237 (Light silver)
  gunmetal: '#5C6670', // RGB: 92, 102, 112 (Gunmetal gray)
  slate: '#9AA0A6', // RGB: 154, 160, 166 (Slate gray)
};

// Legacy alias for backwards compatibility
export const AVINOR_COLORS = OMNITEK_COLORS;

// Risk level color mapping using Omni-Tek brand colors
export const RISK_LEVEL_COLORS = {
  critical: OMNITEK_COLORS.coral, // #FF5252 - Urgent/critical
  high: OMNITEK_COLORS.steel, // #2D3B45 - High attention
  medium: OMNITEK_COLORS.amber, // #FFB300 - Warning
  low: OMNITEK_COLORS.cyan, // #00D9FF - Calm/controlled
  minimal: OMNITEK_COLORS.slate, // #9AA0A6 - Insignificant
};

export const theme = createTheme({
  palette: {
    primary: {
      main: OMNITEK_COLORS.steel,
      dark: OMNITEK_COLORS.darkSteel,
      light: OMNITEK_COLORS.gunmetal,
    },
    secondary: {
      main: OMNITEK_COLORS.cyan,
    },
    warning: {
      main: OMNITEK_COLORS.amber,
    },
    error: {
      main: OMNITEK_COLORS.coral,
    },
    background: {
      default: '#FAFAFA',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});
